module.exports = __webpack_public_path__ + "img/nail-salon.8849cb9f.svg";